import { getUserID, inDevelopment } from '@/helper/util_custom'

const LOCAL_DEV_USER_ID = 'CON202100061077'

// Dev server running on this machine and logged in as LOCAL_DEV_USER_ID
const checkIsLocalDevUser = () => {
  const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname)
  return inDevelopment() && isLocalHost && getUserID() === LOCAL_DEV_USER_ID
}

export default {
  namespaced: true,
  state: {
    isLocalDevUser: checkIsLocalDevUser(),
  },
  mutations: {
    SET_IS_LOCAL_DEV_USER(state, value) {
      state.isLocalDevUser = value
    },
  },
  actions: {
    // User cookie can change on login without a page reload, so re-check before relying on it
    refreshIsLocalDevUser({ commit }) {
      commit('SET_IS_LOCAL_DEV_USER', checkIsLocalDevUser())
    },
  },
}
